module.exports = {
  CREATE_THRESHOLD_REQUEST: 'CREATE_THRESHOLD_REQUEST',
  CREATE_THRESHOLD_SUCCESS: 'CREATE_THRESHOLD_SUCCESS',
  CREATE_THRESHOLD_FAILURE: 'CREATE_THRESHOLD_FAILURE',
  GET_ELEMENT_TYPES_REQUEST: 'GET_ELEMENT_TYPES_REQUEST',
  GET_ELEMENT_TYPES_SUCCESS: 'GET_ELEMENT_TYPES_SUCCESS',
  GET_ELEMENT_TYPES_FAILURE: 'GET_ELEMENT_TYPES_FAILURE',
  DELETE_THRESHOLD_REQUEST: 'DELETE_THRESHOLD_REQUEST',
  DELETE_THRESHOLD_SUCCESS: 'DELETE_THRESHOLD_SUCCESS',
  DELETE_THRESHOLD_FAILURE: 'DELETE_THRESHOLD_FAILURE',
  EDIT_THRESHOLD_REQUEST: 'EDIT_THRESHOLD_REQUEST',
  EDIT_THRESHOLD_SUCCESS: 'EDIT_THRESHOLD_SUCCESS',
  EDIT_THRESHOLD_FAILURE: 'EDIT_THRESHOLD_FAILURE',
};
